<template>
  <el-select
    class="project-selector"
    :value="projectId"
    data-is-search="true"
    @input="handleChangeProject"
    filterable
    :disabled="disabled"
    placeholder="เลือกโครงการ"
    :filter-method="handleFilterMethod"
  >
    <el-option
      v-for="item in projectOptions"
      :key="item.projectId"
      :label="(item.projectId === '') ? 'ทั้งหมด' : `${item.projectName} (${item.projectCode})`"
      :value="item.projectId"
      >{{ (item.projectId === '') ? 'ทั้งหมด' : `${item.projectName} (${item.projectCode})` }}</el-option
    >
  </el-select>
</template>

<script>
import axios from "axios";
import { Select, Option } from "element-ui";
import { getCookie, Auth } from "@/lib/cookie";

export default {
  components: {
    "el-select": Select,
    "el-option": Option,
  },
  props: ["value", "initialProjects", "disabled", "selectedProjectId", "selectedProjectCode"],
  data() {
    const projects = [];
    const query = "";

    return {
      projects,
      query,
    };
  },
  computed: {
    projectOptions() {
      if (!this.query) {
        return this.projects;
      }

      return this.projects.filter((project) => {
        return (
          project.projectName.includes(this.query) ||
          project.projectCode.includes(this.query)
        );
      });
    },
    projectId() {
      // Validate Value
      if (!this.value) return null;

      // Set Selected Project
      let selected = this.selectedProjectCode

      // Find Selected Project in list
      let projectId = selected
        ? this.projects.find(
          project => project.projectCode === (selected.projectCode || selected)
        )
        : this.value;

      // Get Project Id
      return projectId
        ? projectId.projectId
        : null;
    },
  },
  created() {
    this.setupProjects();
  },
  methods: {
    async setupProjects() {
      const projects = await this.fetchProjects();
      projects.unshift({
        "projectId": "",
        "projectCode": "",
        "projectName": "ทั้งหมด",
        "projectIcon": "",
        "projectCover": "",
        "projectType": "",
        "projectSaleStatus": "",
        "projectGroup": "",
        "projectLocation": "",
        "projectTabletCover": null
      })
      if (this.selectedProjectId) {
        const selectedProject = projects.find(
          (project) => project.projectId === this.selectedProjectId
        );
        this.$emit("defaultProject", selectedProject);
      }
      this.projects = projects;
    },
    fetchProjects() {
      if (this.initialProjects) {
        return Promise.resolve(this.initialProjects);
      }

      return axios
        .get(`${process.env.HOST}/api/admin/projects`, {
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
          },
        })
        .then((response) => response.data);
    },
    handleChangeProject(projectId) {
      const project = this.projects.find(
        (project) => project.projectId === projectId
      );

      this.query = "";
      this.$emit("input", project);
    },
    handleFilterMethod(query) {
      this.query = query;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.project-selector {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/lib/components/ProjectSelect.vue